import { ActivityPanel } from "./ActivityPanel";
import { ChartCard } from "./ChartCard";
import { MetricCard } from "./MetricCard";

import type { DashboardPreview } from "@/types/dashboardPreview";

interface DashboardContentProps {

    accent: string;

    preview: DashboardPreview;

    activityTitle: string;

}

export function DashboardContent({

    accent,

    preview,

    activityTitle,

}: DashboardContentProps) {

    return (

        <>

            <div className="grid gap-3 md:grid-cols-4">

                {preview.metrics.map(metric => (

                    <MetricCard

                        key={metric.label}

                        accent={accent}

                        label={metric.label}

                        value={metric.value}

                        trend={metric.trend}

                    />

                ))}

            </div>

            <div className="mt-6 grid gap-3 lg:grid-cols-[1.6fr_1fr]">

                <ChartCard

                    accent={accent}

                    title={preview.chart.title}

                    values={preview.chart.values}

                />

                <ActivityPanel

                    accent={accent}

                    title={activityTitle}

                    items={preview.activities ?? []}

                />

            </div>

        </>

    );

}